import { render, staticRenderFns } from "./XR1.vue?vue&type=template&id=04fa837e&scoped=true"
import script from "./XR1.vue?vue&type=script&lang=js"
export * from "./XR1.vue?vue&type=script&lang=js"
import style0 from "./XR1.vue?vue&type=style&index=0&id=04fa837e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fa837e",
  null
  
)

export default component.exports